import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router-dom';
import dayjs from "../../../../util/dayjs-config";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { TriyoButton, PrimaryButton } from '../../../../components/TriyoButton';
import {
  GetAllWorkflows,
  ArchiveWorkflow,
  // TAD-5644: removed `UnArchiveWorkflow` — never existed as an export and
  // never called in this file. Webpack tolerated the dead import; Vite's
  // strict ESM resolution errors. ArchiveWorkflow(id, archive=false) is the
  // unarchive path.
  SyncWorkflow
} from "../../../../services/api/workflow-api";
import ArchivalModal from "./modals/archival-modal";
import SyncModal from "./modals/sync-modal";
import { errorNotification, successNotification } from '../../../../redux/notifications';
import { selectUser } from "../../../../redux/user/user-selector";
import { FluentButton } from "../../../../components/FluentUI/Fluent-Button";
import FluentUiIcon from "../../../../assets/fluent-ui-icon";
import NoPermissionTable from "../../../../components/no-permission-table/NoPermissionTable";
import './workflow.scss';

const Workflow = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(selectUser);
  const { privileges } = user;
  const canCreate = privileges["Workflow"]?.Add;
  const canEdit = privileges["Workflow"]?.Edit;
  const canArchive = privileges["Workflow"]?.Delete;
  const canViewDetails = privileges["Workflow"]?.Detail;

  const [workflow, setWorkflow] = useState([]);
  const [showArchiveModal, setShowArchiveModal] = useState({});
  const [showUnArchiveModal, setShowUnArchiveModal] = useState({});
  const [showSynceModal, setSyncModal] = useState({});

  useEffect(() => {
    GetWorkflows();
  }, []);

  const GetWorkflows = () => {
    GetAllWorkflows()
      .then((res) => {
        if (res.status === 200) {
          setWorkflow(res.data);
        }
      })
      .catch((err) => {
        console.log("Error [GetAllWorkflows] => ", err);
      });
  }

  const archiveWorkflow = (archiveWorkflow, archive) => {
    ArchiveWorkflow(archiveWorkflow.Id, archive)
      .then((res) => {
        if (res.status === 200) {
          GetWorkflows();
          dispatch(
            successNotification({
              header: "Workflow Archived",
              message: `${res?.data?.Name} Archived Successfully.`,
            })
          );
        }
      })
      .catch((err) => {
        console.log("Error [ArchiveWorkflow] => ", err);
      });
  }

  const syncWorkflow = (archiveWorkflow) => {
    SyncWorkflow(archiveWorkflow.Id)
      .then((res) => {
        if (res.status === 200) {
          GetWorkflows();
          let blob = new Blob([res.data]);
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "SyncLog.txt";
          link.click();
          dispatch(
            successNotification({
              header: "Workflow Sync",
              message: `${archiveWorkflow.Name} Synced Successfully.`,
            })
          );
        }
      })
      .catch((err) => {
        console.log("Error [SyncWorkflow] => ", err);
      });
  }

  const createNewTask = (isLegacy = false) => {
    history.push({
      pathname: "/admin/workflow/create",
      state: { isLegacy },
    });
  };

  const editNewTask = (id, isLegacy = false) => {
    history.push({
      pathname: `/admin/workflow/edit/${id}`,
      state: { isLegacy },
    });
  };

  return (
    <div className="admin-task-types-table-wrapper">
      <div className="admin-panel-table-container">
        <div className="table-control-container">
          <TriyoButton>
            {canCreate ? (
              <PrimaryButton
                onClick={() => createNewTask(false)}
                text="Add New Workflow" 
                disabled={!canCreate}
              />
            ) : (
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>You do not have the requisite Role Privileges to Add Workflow Objects on TRIYO.</Tooltip>}
              >
                <span>
                  <PrimaryButton
                    onClick={() => createNewTask(false)}
                    text="Add New Workflow" 
                    disabled={!canCreate}
                  />
                </span>
              </OverlayTrigger>
            )}
          </TriyoButton>
        </div>
        { canViewDetails ? 
          <div className="table-main workflow-container">
            <table className="table-element">
              <thead className="task-types-table-header">
                <tr >
                  {/* <th className="th-task-types-name-col">ID</th> */}
                  <th className="th-workflow-name-col">NAME</th>
                  <th className="th-workflow-name-col">DESCRIPTION</th>
                  <th className="th-workflow-name-col">INITIAL STATUS</th>
                  <th className="th-workflow-name-col">CREATED</th>
                  <th className="th-workflow-name-col">ACCESS</th>
                  <th className="th-workflow-name-col">ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                { workflow.map((workflow) => {
                  return (
                    <tr key={workflow.Id} className={`template-row-1 ${workflow.Deleted ? 'workflow-table-disabled' : ''}`}>
                      {/* <td className="setting-name settings-data" >{workflow.Id}</td> */}
                      <td className="data-text template-name" >{workflow.Name}</td>
                      <td className="data-text template-name" >{workflow.Description}</td>
                      <td className="data-text template-name" >{workflow.InitialStatus}</td>
                      <td className="data-text template-name" >{dayjs(workflow.Created).format("DD/MM/YYYY")}</td>
                      <td className="data-text template-name" >{workflow.Visible ? "Public" : "Private"}</td>
                      <td className="admin-row-action-buttons workflow-btns">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <FluentButton
                              className={`btn-icon1`}
                              appearance="subtle"
                              icon={<FluentUiIcon name={canEdit ? "EditRegular" : "EyeRegular"} size={18} color={'#0F6CBD'}/>}
                              onClick={() => editNewTask(workflow.Id, !!workflow.Legacy)}
                              disabled={workflow.Deleted}
                              title={canEdit ? "Edit" : "View"}
                          />
                          { workflow.Deleted
                            ? (
                              canArchive ? (
                                <Button
                                  className={`btn-icon1 unarchive-icon`}
                                  onClick={() => setShowUnArchiveModal(workflow)}
                                  title="Un-Archive"
                                  disabled={!canArchive}
                                />
                              ) : (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip>You do not have the requisite Role Privileges to Archive Workflow Objects on TRIYO.</Tooltip>}
                                >
                                  <span style={{ display: 'inline-block' }}>
                                    <Button
                                      className={`btn-icon1 unarchive-icon`}
                                      onClick={() => setShowUnArchiveModal(workflow)}
                                      title="Un-Archive"
                                      disabled={!canArchive}
                                    />
                                  </span>
                                </OverlayTrigger>
                              )
                            ) : (
                              canArchive ? (
                                <Button
                                  className={`btn-icon1 archive-icon2`}
                                  onClick={() => setShowArchiveModal(workflow)}
                                  title="Archive"
                                  disabled={!canArchive}
                                />
                              ) : (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip>You do not have the requisite Role Privileges to Archive Workflow Objects on TRIYO.</Tooltip>}
                                >
                                  <span style={{ display: 'inline-block' }}>
                                    <Button
                                      className={`btn-icon1 archive-icon2`}
                                      onClick={() => setShowArchiveModal(workflow)}
                                      title="Archive"
                                      disabled={!canArchive}
                                    />
                                  </span>
                                </OverlayTrigger>
                              )
                            )
                          }
                          {canEdit ? (
                            <Button
                              className={`btn-icon1 sync-icon`}
                              onClick={() => { setSyncModal(workflow) }}
                              title="Sync"
                              disabled={workflow.Deleted || !canEdit}
                            />
                          ) : (
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip>You do not have the requisite Role Privileges to Edit Workflow Objects on TRIYO.</Tooltip>}
                            >
                              <span style={{ display: 'inline-block' }}>
                                <Button
                                  className={`btn-icon1 sync-icon`}
                                  onClick={() => { setSyncModal(workflow) }}
                                  title="Sync"
                                  disabled={workflow.Deleted || !canEdit}
                                />
                              </span>
                            </OverlayTrigger>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          : <NoPermissionTable />
        }
      </div>
      { showArchiveModal?.Id != undefined &&
        <ArchivalModal
          workflow={showArchiveModal}
          setWorkflowActionModal={setShowArchiveModal}
          acceptAction={archiveWorkflow}
          header="Archive Workflow"
          mainText="Are you sure you want to archive this workflow:"
        />
      }
      { showUnArchiveModal?.Id != undefined &&
        <ArchivalModal
          workflow={showUnArchiveModal}
          setWorkflowActionModal={setShowUnArchiveModal}
          acceptAction={archiveWorkflow}
          header="Un-Archive Workflow"
          mainText="Are you sure you want to un-archive this workflow:"
        />
      }
      { showSynceModal?.Id != undefined &&
        <SyncModal
          workflow={showSynceModal}
          setWorkflowActionModal={setSyncModal}
          acceptAction={syncWorkflow}
          header="Sync Workflow"
          mainText="Sync all existing tasks using this workflow: "
        />
      }
    </div>
  );
}

export default Workflow;
